import API from 'src/services/api';
import Paginated from 'src/types/paginated';

import { JobOptions, Job, CreateJobInput, UpdateExpireDateOptions } from './types';
import { AxiosResponse } from 'axios';

const jobsApi = {
  async fetchJob(id: string): Promise<AxiosResponse<Job>> {
    return await API.get(`/jobs/${id}`);
  },
  async fetchJobs(params: JobOptions = {}, options: { signal?: AbortSignal } = {}): Promise<AxiosResponse<Paginated<Job>>> {
    return await API.get('/jobs', {
      params,
      paramsSerializer: { indexes: null },
      signal: options.signal,
    });
  },
  async createJob(job: CreateJobInput): Promise<AxiosResponse<Job>> {
    return await API.post('/jobs', job);
  },
  async updateJob(payload: UpdateExpireDateOptions): Promise<AxiosResponse<Job>> {
    const url = `/jobs/${payload.id}/${payload.propertyName}`;
    const config = { headers: {'Content-Type': 'text/plain'} };
    return await API.put(url, payload.date, config);
  },
  async deleteJob(id: string): Promise<AxiosResponse<Job>> {
    return await API.delete(`/jobs/${id}`);
  },
};

export default jobsApi;
